import { Skeleton, Table, Tooltip, Typography } from "antd";
import React, { useEffect, useState } from "react";
import Dashboard from "../Layout/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { getStore } from "../../actions/store";
import { formatDate } from "../../utils/Utils";

const Contact = ({ currentUser }) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.store)?.store?.storeContactResponse;
  const { Paragraph } = Typography;

  useEffect(() => {
    setLoading(true);
    dispatch(getStore(currentUser?.store));
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const columns = [
    {
      key: 1,
      title: "Name",
      dataIndex: "userName",
    },
    {
      key: 2,
      title: "Email",
      dataIndex: "email",
      render: (_, record) => <Paragraph copyable>{record?.email}</Paragraph>,
    },
    {
      key: 3,
      title: "Phone",
      dataIndex: "phone",
    },
    {
      key: 4,
      title: "Message",
      dataIndex: "message",
      render: (_, record) => (
        <Tooltip title={record?.message}>
          <p className="w-32 truncate">{record?.message}</p>
        </Tooltip>
      ),
    },
    {
      key: 5,
      title: "Created At",
      render: (_, record) => <p>{formatDate(record?.createdAt)}</p>,
    },
  ];

  return (
    <Dashboard title="Contact">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl m-0 font-bold">Contact</h2>
      </div>
      <div className="bg-white shadow p-4 my-4">
        <Skeleton loading={loading}>
          <Table
            className="cursor-pointer"
            columns={columns}
            dataSource={data}
            scroll={{
              x: 1000,
            }}
            rowKey={(record) => record?._id}
          />
        </Skeleton>
      </div>
    </Dashboard>
  );
};

export default Contact;
